import * as React from 'react';
import { Input, Select, Row, Col, message } from 'antd';
import { PlusOutlined } from '@ant-design/icons';
import Icon from 'common/components/IconFont';
import StaticView from './StaticView';
import * as intl from 'react-intl-universal';
import * as update from 'immutability-helper';

const Option = Select.Option;

export default class DynamicSelect extends React.Component<any, any> {

    // 值变化
    changeHandler = (index: any, key: string) => (val: any) => {
        const { value, onChange } = this.props;
        const data = val.target ? val.target.value : val;
        const newData = update(value, { [index]: { [key]: { $set: data } } });
        onChange && onChange(newData);
    };

    // 增加行数据
    addUpload = () => {
        const { value = [], onChange } = this.props;
        const newData = update(value, { $push: [{ type: '', value: '' }] });
        onChange && onChange(newData);
    };

    // 删除行数据
    removeHandler = (index: number) => {
        const { value, onChange } = this.props;
        const newItems = update(value, { $splice: [[index, 1]] });
        onChange && onChange(newItems);
    };

    // 失焦
    blurHandler = () => {
        const { value , onBlur, onChange } = this.props;
        onBlur ? onBlur(value) : onChange && onChange(value);
    };

    /**
     * 静态数据展示处理
     * @param val
     */
    adaptHandler = (val: any) => {
        const { options = [] } = this.props;
        const display = options && options.filter(({ key }: any) => val.type === key);
        return (display && display.length && `(${display[0].name}) ${val.value || '-'}`) || '-';
    };

    render() {
        const { options = [], placeholder, disabled, staticView, value = [] } = this.props;
        return (staticView && disabled ? (
            !value.length ? '-' : value.map((item: any) =>(
                <div key={item.type}><StaticView display={item} adaptFn={this.adaptHandler} /></div>)))
            :
            <div>
                {value.map(({ type, value }: any, index: any) => {
                    return options && <Row key={`${type}${index}`} style={{ display: 'flex', marginBottom: 8 }}
                            className={(staticView && disabled) ? 'Form-static-view' : ''}>
                            <Col span={5} style={{ marginRight: 8 }}>
                                <Select placeholder={placeholder[0]}
                                    value={type}
                                    dropdownMatchSelectWidth={false} dropdownStyle={{ width: 'auto' }}
                                    suffixIcon={<Icon className="anticon-caret_down" />}
                                    onChange={this.changeHandler(index, 'type')}
                                    disabled={disabled}>
                                    {options && options.map(({ name, key }: any) =>
                                        <Option key={key} value={key} title={name}>{name}</Option>)}
                                </Select>
                            </Col>
                            <Col span={14}>
                                <Input placeholder={placeholder[1]}
                                    value={value}
                                    onChange={this.changeHandler(index, 'value')}
                                    onBlur={this.blurHandler}
                                    disabled={disabled} />
                            </Col>
                            <Col span={4}>
                                {index !== 0 && <a style={{ marginLeft: 8, lineHeight: '32px' }} onClick={() => this.removeHandler(index)}>{intl.get('Global.Delete')}</a>}
                            </Col>
                        </Row>;
                })}
                { value.length < 10 &&
                    <a onClick={this.addUpload}>
                        <PlusOutlined />
                        <span style={{ marginLeft: 6 }}>
                            {intl.get('Global.Add') + intl.get('SignUp.InstantMessage')}</span>
                    </a>
                }
            </div>
        );
    }
}

/**
 * 国家地区选择框(外部传入),不可重复选择同一个值
 * + 输入框
 * 可添加删除
 */
export class AreaSelectInput extends React.Component<any, any> {

    state: any = {
        areaData: [],
    };

    // 存储已设置的国家地区
    setUseAreaData = (values: any[]) => {
        this.setState({
            areaData: values.reduce((prev: Array<string>, curr: any) => prev.concat(curr.area || ''), [])
        });
    };

    // 值变化
    changeHandler = (index: any, key: string) => (val: any) => {
        const { value, onChange } = this.props;
        const data = val.target ? val.target.value : val;
        const newData = update(value, { [index]: { [key]: { $set: data } } });
        this.setUseAreaData(newData);
        onChange && onChange(newData);
    };

    // 增加行数据
    addUpload = () => {
        const { value = [], onChange } = this.props;
        if (value.length >= 50) {
            message.error(intl.get('SignUp.AddUpperLimit', { field: 50 }));
            return;
        }
        const newData = update(value, { $push: [{ area: '', taxNumber: '' }] });
        onChange && onChange(newData);
    };

    // 删除行数据
    removeHandler = (index: number) => {
        const { value, onChange } = this.props;
        const newItems = update(value, { $splice: [[index, 1]] });
        this.setUseAreaData(newItems);
        onChange && onChange(newItems);
    };

    // 失焦
    blurHandler = () => {
        const { value, onBlur, onChange } = this.props;
        onBlur ? onBlur(value) : onChange && onChange(value);
    };

    /**
     * 静态数据展示处理
     * @param val
     */
    adaptHandler = (val: any) => {
        const { options = [] } = this.props;
        const display = options && options.filter(({ value }: any) => val.area === value);
        return (display && display.length && `(${display[0].label}) ${val.taxNumber || '-'}`) || '-';
    };

    filterNodes = (config: any) => {
        const { options = [] } = this.props;
        return options.map((item: any) => {
            return {
                ...item,
                disabled: this.state.areaData.includes(item.value) && (config.area !== item.value)
            };
        });
    };

    render() {
        const { options = [], placeholder, disabled, staticView, value = [] } = this.props;
        return (staticView && disabled ? (
            !value.length ? '-' : <div>
                {value.map((item: any) => (
                    <div key={item.type} style={{ lineHeight: '23px' }}><StaticView display={item} adaptFn={this.adaptHandler} /></div>
                ))}
            </div>)
            :
            <div>
                {value.map(({ area, taxNumber }: any, index: any) => {
                    return options && <Row key={`${area}${index}`} style={{ display: 'flex', marginBottom: 8 }}
                        className={(staticView && disabled) ? 'Form-static-view' : ''}>
                        <Col span={5} style={{ marginRight: 8 }}>
                            <Select placeholder={placeholder[0]}
                                value={area}
                                dropdownMatchSelectWidth={false} dropdownStyle={{ width: 'auto' }}
                                suffixIcon={<Icon type="caret-down" />}
                                onChange={this.changeHandler(index, 'area')}
                                disabled={disabled}>
                                {options && this.filterNodes(value[index]).map(({ label, value, disabled }: any, index: number) =>
                                    <Option key={index} value={value} title={label} disabled={disabled}>{label}</Option>)}
                            </Select>
                        </Col>
                        <Col span={14}>
                            <Input placeholder={placeholder[1]}
                                value={taxNumber}
                                onChange={this.changeHandler(index, 'taxNumber')}
                                onBlur={this.blurHandler}
                                disabled={disabled} />
                        </Col>
                        <Col span={4}>
                            <a style={{ marginLeft: 8, lineHeight: '32px' }} onClick={() => this.removeHandler(index)}>{intl.get('Global.Delete')}</a>
                        </Col>
                    </Row>;
                })}
                <a onClick={this.addUpload}>
                    <PlusOutlined />
                    <span style={{ marginLeft: 6 }}>
                        {intl.get('Global.Add') + intl.get('SignUp.TaxResidence')}</span>
                </a>
            </div>
        );
    }
}
